import * as React             from 'react'
import { FormattedMessage }   from 'react-intl'
import { connect }            from 'react-redux'
import { bindActionCreators } from 'redux'

import Button        from '@material-ui/core/Button'
import Dialog        from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle   from '@material-ui/core/DialogTitle'

import { hasToAcceptContract }                           from '../../project-utils/permissions'
import { agreeToContract, selectContractAccepted }       from '../../redux'
import withAccountType, { InjectedWithAccountTypeProps } from '../hocs/withAccountType'

const mstp = state =>
  ({ hasAcceptedContract: selectContractAccepted(state) })

const mdtp = dispatch =>
  bindActionCreators(({ agree: agreeToContract }), dispatch)

type Props =
  InjectedWithAccountTypeProps
  & ReturnType<typeof mstp>
  & ReturnType<typeof mdtp>

const Contract: React.SFC<Props> = ({
  agree,
  hasAcceptedContract,
  accountType,
}) => {
  if (!hasToAcceptContract(accountType)) return null

  return (
    <Dialog open={!hasAcceptedContract}>
      <DialogTitle>
        <FormattedMessage id={'generic.contractDialogTitle'} />
      </DialogTitle>
      <DialogContent style={{ textAlign: 'justify' }}>
        {'THIS IS WHERE THE CONTRACT GOES'.repeat(100)}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={agree}
          color={'primary'}
        >
          <FormattedMessage id={'buttonActions.agree'} />
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default connect(mstp, mdtp)(withAccountType(Contract))



// WEBPACK FOOTER //
// ./src/components/organisms/Contract.tsx